import { useEffect } from "react";
import { ref, onValue, onDisconnect, set, serverTimestamp } from "firebase/database";
import { rtdb } from "../firebase";

export default function usePresence(user) {
  useEffect(() => {
    if (!user?.uid) return;

    const userStatusRef = ref(rtdb, `/status/${user.uid}`);
    const isConnectedRef = ref(rtdb, ".info/connected");

    const unsubscribe = onValue(isConnectedRef, (snap) => {
      if (snap.val() === false) {
        return;
      }

      onDisconnect(userStatusRef)
        .set({
          state: "offline",
          last_changed: serverTimestamp(),
        })
        .then(() => {
          set(userStatusRef, {
            state: "online",
            last_changed: serverTimestamp(),
          });
        });
    });

    return () => {
      unsubscribe();
      // Set offline explicitly on unmount to ensure immediate feedback
      // We use a disjoint update because auth might be clearing, but if we still have permission it helps.
      set(userStatusRef, {
        state: "offline",
        last_changed: serverTimestamp(),
      }).catch(e => {
        // Ignore permission errors if auth is already gone
      });
    };
  }, [user]);
}
